import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonVariants } from '@levelaccess/design-system';

import { IModalDialogInputData } from '../../interfaces/modal-dialog.interface';

@Component({
  selector: 'app-share-issue-report-modal',
  templateUrl: './share-issue-report-modal.component.html',
  styleUrls: ['./share-issue-report-modal.component.scss'],
  standalone: false,
})
export class ShareIssueReportModalComponent {
  @Input() public modalInputData: IModalDialogInputData<{ url: string }>;

  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  constructor(public modal: NgbActiveModal) {}
}
